(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[id^="FeaturedEditorial-"]').forEach(section => {
      const slides = [...section.querySelectorAll('[data-slide]')];
      if (slides.length <= 1) return;
      let current = 0;

      const show = (idx) => {
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        current = (idx + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        slides[current].setAttribute('aria-hidden', 'false');
      };

      section.querySelectorAll('[data-fe-prev]').forEach(btn =>
        btn.addEventListener('click', () => show(current - 1))
      );
      section.querySelectorAll('[data-fe-next]').forEach(btn =>
        btn.addEventListener('click', () => show(current + 1))
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
